import React from 'react'
import { appConfig } from 'config'
import { MyGoogleMap } from 'Components/utilities'
import { DetailDrawer } from 'Components/common/MainLayout'
import { Data } from 'Store/orders/types'
import styled from 'styled-components'
const MyGoogleMaps: any = MyGoogleMap

type Props = {
  isShow: boolean
  onClose: () => void
  detail?: Data
}

const MapDrawer = (props: Props) => {
  const { isShow, onClose, detail } = props

  return (
    <DetailDrawer title="แผนที่" width={'50%'} onCloseDrawer={onClose} visible={isShow} maskClosable={true}>
      <MapWrapper>
        <MyGoogleMaps
          lat={detail?.shipping_address?.lat || 0}
          long={detail?.shipping_address?.long || 0}
          isMarkerShown
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${appConfig.googleMapKey}`}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: '60vh' }} />}
          mapElement={<div style={{ height: `100%`, borderRadius: '10px' }} />}
          icon="customer"
        />
      </MapWrapper>
    </DetailDrawer>
  )
}

const MapWrapper = styled.div`
  padding: 10px 0;
  .gmnoprint {
    bottom: 12px;
    top: auto !important;
  }
  .ant-input-affix-wrapper {
    margin: 1%;
    //width: 80% !important;
  }
`

export default MapDrawer
